import './DateCell.scss';
import React, { Fragment } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { InputType } from 'Models/FormModels';
import { dayjs } from 'Utilities/DateTimeUtc';
import { GridInput } from './GridInput';
import WarningIcon from '@mui/icons-material/Warning';
import { yellow } from '@mui/material/colors';
import { template } from 'lodash';

export type DateCellProps = GridCellProps & {
  dateFormat?: string;
  disableUtcConversion?: boolean;
};

export type WarningDateCellProps = DateCellProps & {
  shouldDisplayField: string;
};

export const DateCell: React.FC<DateCellProps> = (props) => {
  return (
    <td>
      <DateCellContent {...props} />
    </td>
  );
};

export const FileDateCell: React.FC<DateCellProps> = (props) => {
  return (
    <td>
      <FileDateCellContent {...props} />
    </td>
  );
};

export const WarningDateCell: React.FC<WarningDateCellProps> = ({
  shouldDisplayField,
  dataItem,
  ...props
}) => {
  const shouldDisplayWarningIcon = dataItem[shouldDisplayField];

  return (
    <td>
      <DateCellContent {...props} dataItem={dataItem} />
      {shouldDisplayWarningIcon ? (
        <WarningIcon style={{ color: yellow[700] }} />
      ) : (
        <Fragment />
      )}
    </td>
  );
};

export const DateCellContent: React.FC<DateCellProps> = ({
  dataItem,
  field,
  onChange,
  dateFormat,
  disableUtcConversion,
}) => {
  const value = dataItem[field as string] as Date;

  const getFormattedDate = () => {
    if (!value) return '';
    const d = disableUtcConversion ? dayjs(value) : dayjs.utc(value).local();
    if (!d.isValid() || d.year() <= 1) return '';
    return d.format(dateFormat || 'l');
  };

  return (
    <Fragment>
      {dataItem.inEdit ? (
        <GridInput
          dataItem={dataItem}
          name={field as string}
          type={InputType.DatePicker}
          onChange={onChange}
          value={value}
        />
      ) : (
        getFormattedDate()
      )}
    </Fragment>
  );
};

const FileDateCellContent: React.FC<DateCellProps> = ({
  dataItem,
  field,
  onChange,
  dateFormat,
  disableUtcConversion,
}) => {
  let value: Date | undefined;

  switch (field) {
    case 'templateFile.uploadDate': {
      value = dataItem.templateFile.uploadDate as Date;
      break;
    }
    case 'reportFile.uploadDate': {
      value = dataItem.reportFile.uploadDate as Date;
      break;
    }
    default: {
      break;
    }
  }

  const getFormattedDate = () => {
    if (!value) return '';
    const d = disableUtcConversion ? dayjs(value) : dayjs.utc(value).local();
    if (!d.isValid() || d.year() <= 1) return '';
    return d.format(dateFormat || 'l');
  };

  return (
    <Fragment>
      {dataItem.inEdit ? (
        <GridInput
          dataItem={dataItem}
          name={field as string}
          type={InputType.DatePicker}
          onChange={onChange}
          value={value}
        />
      ) : (
        getFormattedDate()
      )}
    </Fragment>
  );
};
